<template>
  <div>
    <div id="container">
      <!-- Navigation -->
      <CommonNavbar />

      <!-- BANNER -->
      <div style="width: 100%; overflow: hidden; margin-top: -3px; height: 400px;" id="mainbanner" data-aos="fade-down" data-aos-duration="1500">
        <div style="width: 100%; margin-right: auto; height: 100%;">
          <a  target="_blank" style="display: block; width: 100%; height: 100%;">
            <img class="banner-img" alt="Responsive image" :src="require('@/assets/society/isacibanner.jpg')" style="width: 100%; height: 100%; object-fit: cover;">
          </a>
        </div>
      </div>
      <div style="width: 100%; overflow: hidden; height: 300px;" id="mob">
        <div style="width: 100%; margin-right: auto; height: 100%;">
          <a  target="_blank" style="display: block; width: 100%; height: 100%;">
            <img class="banner-img" alt="Responsive image" :src="require('../assets/society/isacibanner.jpg')" style="width: 100%; height: 100%; object-fit: cover;">
          </a>
        </div>
      </div>

      
      <!-- Main Content -->
      <div class="container main-content">
        <div class="row mb-4">
          <div class="col-12">
            <div class="quick-actions" data-aos="fade-up" data-aos-duration="1200">
               <router-link class="quick-action-item"  to="/Registration">
                <i class="fa-solid fa-user-plus"></i>
                <span>Register For Workshop</span>
              </router-link>
              <!-- <div class="quick-action-item" @click="scrollToSection('abstract')">
                <i class="fa-solid fa-file-text"></i>
                <span>Submit abstract</span>
              </div>
              <div class="quick-action-item" @click="scrollToSection('hotel')">
                <i class="fa-solid fa-bed"></i>
                <span>Hotel reservation</span>
              </div>
              <div class="quick-action-item" @click="scrollToSection('exhibition')">
                <i class="fa-solid fa-store"></i>
                <span>Exhibition sponsorship</span>
              </div> -->
            </div>
          </div>
        </div>

         <div class="row mt-4">
          <div class="col-12">
            <div class="workshop-section" data-aos="fade-up" data-aos-duration="1500">
              <h3 class="section-title">The Asian and Oceania Workshop on Data, Inference and Security</h3>
              <div class="workshop-content">
                <div class="workshop-header">
                  <div class="workshop-info-cards">
                    <div class="info-card">
                      <i class="fa-solid fa-map-marker-alt"></i>
                      <div>
                        <h6>Location</h6>
                        <p>Penang, Malaysia</p>
                      </div>
                    </div>
                    <div class="info-card">
                      <i class="fa-solid fa-calendar"></i>
                      <div>
                        <h6>Date</h6>
                        <p>
                          14 - 16 Nov 2025</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="workshop-description">
                  <p>This workshop aims to foster collaboration and knowledge exchange among researchers and 
                    professionals across the Asia-Pacific and Oceania regions.</p>
                </div>

                <div class="workshop-topics">
                  <h5>Topics will include, but are not limited to:</h5>
                  <div class="topics-grid">
                    <div class="topic-item">
                      <i class="fa-solid fa-calculator"></i>
                      <span>Data analysis </span>
                    </div>
                    <div class="topic-item">
                      <i class="fa-solid fa-chart-line"></i>
                      <span>Statistical inference</span>
                    </div>
                    <div class="topic-item">
                      <i class="fa-solid fa-cube"></i>
                      <span> Computational methods</span>
                    </div>
                    <div class="topic-item">
                      <i class="fa-solid fa-network-wired"></i>
                      <span> Information security</span>
                    </div>
                    <div class="topic-item topic-item-full">
                      <i class="fa-solid fa-shield-alt"></i>
                      <span>Explore cross-disciplinary approaches to emerging challenges in data-driven research and 
                        secure computation</span>
                    </div>
                    <!-- <div class="topic-item">
                      <i class="fa-solid fa-optimize"></i>
                      <span>Optimization techniques in inverse problems and learning systems</span>
                    </div>
                    <div class="topic-item">
                      <i class="fa-solid fa-atom"></i>
                      <span>Mathematical modeling of physical and data-driven processes</span>
                    </div>
                    <div class="topic-item">
                      <i class="fa-solid fa-image"></i>
                      <span>AI-assisted imaging and signal processing</span>
                    </div> -->
                  </div>
                </div>

                <div class="workshop-format">
                  <h5>Workshop Format</h5>
                  <p>Through a series of invited talks and contributed presentations, participants will gain insights into the latest trends and open problems at the interface of mathematics and intelligence.</p>
                </div>

                <div class="workshop-participation">
                  <h5>Call for Participation</h5>
                  <p>We welcome contributions from a broad range of disciplines including mathematics, computer science, statistics, and engineering. Whether you're an academic researcher, industry expert, or graduate student, this workshop offers a unique opportunity to engage with the frontier of innovation in this exciting and rapidly growing field.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- News and Updates Section -->
        <!-- <div class="row mt-4">
          <div class="col-12">
            <div class="news-section" data-aos="fade-up" data-aos-duration="1500">
              <h3 class="section-title">最新动态</h3>
              <div class="news-grid">
                <div class="news-item">
                  <div class="news-icon">
                    <i class="fa-solid fa-bullhorn"></i>
                  </div>
                  <div class="news-content">
                    <h6>会议日程已发布</h6>
                    <p>查看详细的会议安排和演讲时间表</p>
                    <a href="docs/Program_Overview.pdf" target="_blank">查看详情</a>
                  </div>
                </div>
                <div class="news-item">
                  <div class="news-icon">
                    <i class="fa-solid fa-users"></i>
                  </div>
                  <div class="news-content">
                    <h6>青年学者论坛</h6>
                    <p>为青年研究人员提供展示和交流的平台</p>
                    <a href="#">了解更多</a>
                  </div>
                </div>
                <div class="news-item">
                  <div class="news-icon">
                    <i class="fa-solid fa-trophy"></i>
                  </div>
                  <div class="news-content">
                    <h6>海报竞赛</h6>
                    <p>学生海报展示竞赛现已开放报名</p>
                    <a href="#">参与竞赛</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Footer -->
      <!-- <CommonFooter /> -->
      <TheFooter />
    </div>
  </div>
</template>

<script>
// import CommonFooter from '@/components/CommonFooter.vue'
import CommonNavbar from '@/components/CommonNavbar.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
  name: 'AOGS2025',
  components: {
    // CommonFooter,
    CommonNavbar,
    TheFooter
  },
  data() {
    return {
      // 图片路径
      backgroundImage1: null,
      backgroundImage2: null,
      // 倒计时数据
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      // 会议开始时间 (2025年6月24日)
      conferenceDate: new Date('2025-06-24T09:00:00')
    }
  },
  mounted() {
    
    // 将MM_openBrWindow函数添加到全局window对象
    window.MM_openBrWindow = this.MM_openBrWindow
    
    // jQuery ready start
    $(document).ready(() => {
      // Prevent closing from click inside dropdown
      $(document).on('click', '.dropdown-menu', function (e) {
        e.stopPropagation()
      })
    })

    // Initialize AOS
    if (window.AOS) {
      window.AOS.init()
    }

    // 启动倒计时
    // this.startCountdown()
  },
  methods: {
    MM_openBrWindow(theURL, winName, features) {
      window.open(theURL, winName, features);
    },
    
    startCountdown() {
      const timer = setInterval(() => {
        const now = new Date().getTime()
        const distance = this.conferenceDate.getTime() - now

        if (distance < 0) {
          clearInterval(timer)
          this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 }
          return
        }

        this.countdown.days = Math.floor(distance / (1000 * 60 * 60 * 24))
        this.countdown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.countdown.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        this.countdown.seconds = Math.floor((distance % (1000 * 60)) / 1000)
      }, 1000)
    },

    scrollToSection(section) {
      if(section == 'registration'){
        // this.$router.push('/meetings/SupportAndResources#VHO')
        window.location.href = 'https://isacio.apiwww.cn/#/registration'
      }
      if(section == 'abstract'){
        // this.$router.push('/meetings/SupportAndResources#hotel-booking')
        window.location.href = 'https://isacio.apiwww.cn/#/my-abstracts'
      }
      if(section == 'hotel'){
        this.$router.push('/meetings/SupportAndResources#hotel-booking')
       
      }
      if(section == 'Exhibition'){
        this.$router.push('/meetings/exhibitor-sponsor')
      }
    },
    
    openLink(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style>

/* 导入原始样式 */
.MMI-text-HP {
  font-size: 14.5px;
  margin-bottom: 10px;
  line-height: 1.2;
  font-weight: 500;
  color: darkslategrey;
  margin-bottom: 0px;
  margin-top: 0px;
}

.MMI-text-HP1 {
  font-size: 13.5px;
  margin-bottom: 10px;
  line-height: 1.4;
  font-weight: 500;
}

/* Default link styling */
.MMI-text-HP a {
  color: black;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
}

/* Hover effect - Change text color and show arrow */
.MMI-text-HP a:hover {
  color: #073787; /* Blue */
}

/* Hide the arrow by default */
.MMI-text-HP a i {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

/* Show arrow on hover or when clicked */
.MMI-text-HP a:hover i,
.MMI-text-HP a:active i {
  visibility: visible;
  opacity: 1;
}

/* Welcome Section */
.welcome-section {
  background: linear-gradient(135deg, #000E70 0%, #073787 50%, #1e4db7 100%);
  color: white;
  padding: 40px 0;
  text-align: center;
  margin-bottom: 30px;
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.welcome-subtitle {
  font-size: 1.2rem;
  margin-bottom: 30px;
  opacity: 0.9;
}

.countdown-timer {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255,255,255,0.1);
  padding: 15px 20px;
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.2);
}

.countdown-number {
  font-size: 2rem;
  font-weight: bold;
  color: #ffd700;
}

.countdown-label {
  font-size: 0.9rem;
  margin-top: 5px;
}

.welcome-text {
  font-size: 1.1rem;
  opacity: 0.8;
}

/* Quick Actions */
.quick-actions {
  display: flex;
  justify-content: space-around;
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.quick-action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 15px;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-align: center;
  text-decoration: none;
}

.quick-action-item:hover {
  background: #f8f9fa;
  transform: translateY(-5px);
  text-decoration: none;
}

.quick-action-item i {
  font-size: 2rem;
  color: #000E70;
  margin-bottom: 10px;
}

.quick-action-item span {
  font-weight: 600;
  color: #333;
}

/* Main Content */
.main-content {
  padding: 20px 0;
  max-width: 1300px !important;
}

/* Main Registration Card */
.main-registration-card {
  position: relative;
  overflow: hidden;
}

.main-registration-card img {
  transition: transform 0.3s ease;
}

.main-registration-card:hover img {
  transform: scale(1.05);
}

.card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  color: white;
  padding: 20px;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.main-registration-card:hover .card-overlay {
  transform: translateY(0);
}

/* Venue Card */
.venue-card {
  position: relative;
  overflow: hidden;
}

.venue-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  color: white;
  padding: 20px;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.venue-card:hover .venue-overlay {
  transform: translateY(0);
}

/* Custom Card Styles */
.custom-card {
  position: relative;
  background-size: cover;
  background-position: center;
  min-height: 290px;
  color: white;
  overflow: hidden;
  border-radius: 10px;
  padding: 20px;
  transition: all 0.5s ease-in-out;
  margin-bottom: 20px;
}

/* Gradient black overlay (Left to Right) */
.custom-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  z-index: 1;
}

/* Dim effect on background image only */
.custom-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  transition: background 0.5s ease-in-out;
  z-index: 2;
}

.custom-card:hover::after {
  background: rgba(0, 14, 112, 0.5);
}

/* Ensure content is above overlays */
.custom-card > * {
  position: relative;
  z-index: 3;
}

/* Header styling */
.custom-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: white;
  margin-bottom: 12px;
  margin-top: -5px;
  text-shadow: 1px 1px 8px rgba(0, 0, 0, 1);
}

.custom-card-header i {
  color: white;
}

/* Links container */
.custom-card-links {
  display: flex;
  font-size: 20px;
  line-height: 1.6;
  font-weight: 550;
  flex-direction: row;
  margin-top: 80px;
  justify-content: space-around;
  align-items: center;
}

/* General links styling */
.custom-card-links a {
  display: flex;
  text-decoration: none;
  color: white;
  font-size: 14px;
  align-items: center;
  transition: all 0.4s ease-in-out;
  text-shadow: 1px 1px 8px rgba(0, 0, 0, 1);
  margin-bottom: 8px;
}

.custom-card-links a i {
  opacity: 0;
  color: yellow;
  transition: opacity 0.3s ease-in-out;
  margin-left: 5px;
}

/* Hover effect */
.custom-card-links a:hover {
  color: #ffd700;
}

.custom-card-links a:hover i {
  opacity: 1;
}

/* Legacy deadline styles - kept for compatibility */

/* Legacy stats styles - kept for compatibility */

/* Legacy detailed deadlines styles - kept for compatibility */

/* Workshop Section */
.workshop-section {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  margin-top: 0px;
  margin-bottom: 20px;
}

.workshop-content {
  max-width: 100%;
}

.workshop-header {
  margin-bottom: 30px;
}

.workshop-info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.info-card {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #000E70;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.info-card i {
  font-size: 24px;
  color: #000E70;
  margin-right: 15px;
  width: 30px;
  text-align: center;
}

.info-card h6 {
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-card p {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.workshop-description {
  background: linear-gradient(135deg, #000E70 0%, #073787 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 30px;
  text-align: center;
}

.workshop-description p {
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
  font-weight: 500;
}

.workshop-topics {
  margin-bottom: 30px;
}

.workshop-topics h5 {
  color: #000E70;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
}

.workshop-topics h5::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #000E70, #073787);
  border-radius: 2px;
}

.topics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
  gap: 15px;
}

.topic-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 20px 20px;
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.topic-item:hover {
  border-color: #000E70;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,14,112,0.15);
}

.topic-item i {
  font-size: 20px;
  color: #000E70;
  margin-right: 15px;
  width: 25px;
  text-align: center;
}

.topic-item span {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.topic-item-full {
  grid-column: 1 / -1;
}

.workshop-format,
.workshop-participation {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 12px;
  margin-bottom: 25px;
  border-left: 4px solid #000E70;
}

.workshop-format h5,
.workshop-participation h5 {
  color: #000E70;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}

.workshop-format p,
.workshop-participation p {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  margin: 0;
}

/* News Section */
.news-section {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  margin-top: 40px;
}

/* Link Cards */
.link-card {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
}

.link-card:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.link-card-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.link-card-icon i {
  color: white;
  font-size: 16px;
}

.link-card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  color: white;
}

.link-card-content span {
  font-size: 16px;
  font-weight: 600;
  text-shadow: 1px 1px 8px rgba(0, 0, 0, 1);
}

.link-card-content i {
  opacity: 0;
  color: #ffd700;
  transition: opacity 0.3s ease-in-out;
  margin-left: 10px;
}

.link-card:hover .link-card-content i {
  opacity: 1;
}

.section-title {
  text-align: center;
  color: #000E70;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 30px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #000E70, #073787);
  border-radius: 2px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
}

.news-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
  border-left: 4px solid #000E70;
}

.news-item:hover {
  background: white;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  transform: translateY(-5px);
}

.news-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #000E70, #073787);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.news-icon i {
  color: white;
  font-size: 20px;
}

.news-content h6 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.news-content p {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.news-content a {
  color: #000E70;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition: color 0.3s ease;
}

.news-content a:hover {
  color: #073787;
  text-decoration: underline;
}

/* Ensure all cards have the same minimum height */
.MMI-cardHoverEffect {
  min-height: 140px;
  display: flex;
  flex-direction: column;
}

.MMI-cardHoverEffect .row {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.MMI-cardHoverEffect .col-4 {
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: stretch;
  border-radius: 0.375rem 0 0 0.375rem;
}

.MMI-cardHoverEffect .col-4 img {
  transition: transform 0.3s ease-in-out;
  object-fit: cover;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  border-radius: inherit;
}

/* Image zoom-out effect on hover */
.MMI-cardHoverEffect:hover .col-4 img {
  transform: scale(1.05);
}

/* Set icon color */
.icon-square img {
  width: 22px;
  height: 22px;
  transition: none !important;
  color: #000E70;
}

/* Glow Effect */
.card-glow {
  transition: box-shadow 0.3s ease-in-out;
}

.card-glow:hover {
  box-shadow: 0 0 15px 5px rgba(255, 223, 0, 0.5);
}

/* MMI Card Floating Effect */
.MMI-cardFloatingEffect {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.MMI-cardFloatingEffect:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

/* Responsive Design */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 2rem;
  }
  
  .countdown-timer {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .countdown-item {
    padding: 10px 15px;
  }
  
  .countdown-number {
    font-size: 1.5rem;
  }
  
  .quick-actions {
    flex-direction: column;
    gap: 15px;
  }
  
  .quick-action-item {
    flex-direction: row;
    justify-content: flex-start;
  }
  
  .quick-action-item i {
    margin-right: 15px;
    margin-bottom: 0;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .news-item {
    flex-direction: column;
    text-align: center;
  }
  
  .news-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  

  
  /* Workshop responsive */
  .workshop-info-cards {
    grid-template-columns: 1fr;
  }
  
  .topics-grid {
    grid-template-columns: 1fr;
  }
  
  .workshop-description p {
    font-size: 16px;
  }
  
  .topic-item {
    padding: 12px 15px;
  }
  
  .topic-item span {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  .welcome-section {
    padding: 20px 0;
  }
  
  .welcome-title {
    font-size: 1.5rem;
  }
  
  .welcome-subtitle {
    font-size: 1rem;
  }
  
  .countdown-timer {
    gap: 5px;
  }
  
  .countdown-item {
    padding: 8px 12px;
  }
  
  .countdown-number {
    font-size: 1.2rem;
  }
  
  .countdown-label {
    font-size: 0.8rem;
  }
  
  .main-content {
    padding: 10px 0;
  }
  
  .news-section {
    padding: 20px;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
}

/* Footer styles */
.MMI-footerLogo {
  height: 60px;
  width: auto;
  margin-bottom: 10px;
}

.MMI-footerTitle {
  color: white;
  font-size: 16px;
  margin-bottom: 10px;
}

.MMI-footerText {
  color: #ccc;
  font-size: 14px;
  line-height: 1.4;
}

.MMI-footerLink {
  color: #4CAF50;
  text-decoration: none;
}

.MMI-footerLink:hover {
  color: #66BB6A;
}

/* Banner responsive */
@media (max-width: 768px) {
  #mainbanner {
    display: none;
  }
  
  #mob {
    display: block;
  }
}

@media (min-width: 769px) {
  #mainbanner {
    display: block;
  }
  
  #mob {
    display: none;
  }
}

/* Animation enhancements */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Info Cards Section Styles */
.info-cards-section {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  height: 100%;
  transition: all 0.3s ease;
}

.info-cards-section:hover {
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  transform: translateY(-3px);
}

.info-cards-title {
  display: flex;
  align-items: center;
  color: #000E70;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.info-cards-title i {
  margin-right: 10px;
  font-size: 20px;
  color: #000E70;
}

.info-cards-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s ease;
  border-left: 4px solid #000E70;
  cursor: pointer;
}

.info-card-item:hover {
  background: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  transform: translateX(5px);
}

.info-card-item.urgent {
  border-left-color: #dc3545;
  background: linear-gradient(135deg, #fff5f5 0%, #f8f9fa 100%);
}

.info-card-item.urgent:hover {
  background: linear-gradient(135deg, #ffe6e6 0%, #fff 100%);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.2);
}

.info-card-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #000E70, #073787);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.info-card-item.urgent .info-card-icon {
  background: linear-gradient(135deg, #dc3545, #c82333);
}

.info-card-icon i {
  color: white;
  font-size: 18px;
}

.info-card-content {
  flex-grow: 1;
}

.info-card-content h6 {
  margin: 0 0 5px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-card-content p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.info-card-item.urgent .info-card-content h6 {
  color: #dc3545;
}

/* Responsive adjustments for info cards */
@media (max-width: 768px) {
  .info-cards-section {
    padding: 20px;
  }
  
  .info-cards-title {
    font-size: 16px;
  }
  
  .info-cards-title i {
    font-size: 18px;
  }
  
  .info-card-item {
    padding: 12px;
  }
  
  .info-card-icon {
    width: 40px;
    height: 40px;
  }
  
  .info-card-icon i {
    font-size: 16px;
  }
  
  .info-card-content h6 {
    font-size: 15px;
  }
  
  .info-card-content p {
    font-size: 13px;
  }
}

/* Legacy deadline animation - kept for compatibility */

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #000E70;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #073787;
}
</style>